import { useRef, useEffect } from 'react';
import imagesLoaded from 'imagesloaded';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import styles from './ScrollingText.module.scss';

import Scrollvideo from "./media/tommy_media_phase2.mp4";

export default function ScrollingText(){
	const wrapper = useRef(null);
	const text1 = useRef(null);
	const text2 = useRef(null);
	const text3 = useRef(null);

	useEffect(() => {
		imagesLoaded(document.querySelectorAll('img'), {background: true}, () => {
			gsap.registerPlugin(ScrollTrigger);
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: wrapper.current,
					start: "top bottom",
					end: "bottom top",
					scrub: 0.3,
			    onUpdate: self => {
			    }
				}
			});

			tl.fromTo(text1.current, {
				x: '0vw'
			}, {
				x: '-100vw'
			}, 0).fromTo(text2.current, {
				x: '0vw'
			}, {
				x: '100vw'
			}, 0).fromTo(text3.current, {
				x: '0vw'
			}, {
				x: '-100vw'
			}, 0);
			ScrollTrigger.refresh();
		});
	}, []);

	return (
		<div className={styles.wrap} ref={wrapper}>

			<video controls={false} playsInline autoPlay loop muted>
      	<source src={Scrollvideo} type="video/mp4" />
	    </video>

			<div className={styles.textSpacer}>
				<h1 ref={text1}>TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND</h1>
				<h1 className={styles.middle_Text} ref={text2}>TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND</h1>
				<h1 ref={text3}><span>TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND TOMMYXTIMBERLAND</span></h1>
			</div>
		</div>
	)
}